import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { LangContext, translations } from "@/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Manifesto from "@/components/Manifesto";
import Rooms from "@/components/Rooms";
import Amenities from "@/components/Amenities";
import Gallery from "@/components/Gallery";
import Surroundings from "@/components/Surroundings";
import Reviews from "@/components/Reviews";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import { LightboxProvider } from "@/components/Lightbox";

function App() {
  const [lang, setLang] = useState("it");
  const t = translations[lang];

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      <LightboxProvider>
        <div className="bg-[#F9F8F6] text-[#14213D] font-sans antialiased">
          <div className="noise-overlay" />
          <Navbar />
          <main>
            <Hero />
            <EditorialMarquee />
            <Manifesto />
            <Rooms />
            <Amenities />
            <Gallery />
            <Surroundings />
            <Reviews />
            <Contact />
          </main>
          <Footer />
          <WhatsAppButton />
          <Toaster position="bottom-right" richColors />
        </div>
      </LightboxProvider>
    </LangContext.Provider>
  );
}

export default App;
